import { put, call, all, takeLatest, select } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOnePeriodicCheck,
  GET_ONE_PERIODIC_CHECK,
  GET_ONE_PERIODIC_CHECK_ERROR,
  GET_ONE_PERIODIC_CHECK_SUCCESS,
} from '../types/periodic-check/get-one'

import {
  GET_LAST_PERIODIC_CHECK,
  GET_LAST_PERIODIC_CHECK_ERROR,
  GET_LAST_PERIODIC_CHECK_SUCCESS,
} from '../types/periodic-check/get-last'

import {
  GetAllPeriodicsChecks,
  GET_ALL_PERIODICS_CHECKS,
  GET_ALL_PERIODICS_CHECKS_ERROR,
  GET_ALL_PERIODICS_CHECKS_SUCCESS,
} from '../types/periodic-check/get-all'

import {
  NewPeriodicCheck,
  NEW_PERIODIC_CHECK,
  NEW_PERIODIC_CHECK_ERROR,
  NEW_PERIODIC_CHECK_SUCCESS,
} from '../types/periodic-check/new'

import {
  EditPeriodicCheck,
  EDIT_PERIODIC_CHECK,
  EDIT_PERIODIC_CHECK_ERROR,
  EDIT_PERIODIC_CHECK_SUCCESS,
} from '../types/periodic-check/edit'

import {
  EditPeriodicCheckState,
  EDIT_PERIODIC_CHECK_STATE,
  EDIT_PERIODIC_CHECK_STATE_ERROR,
  EDIT_PERIODIC_CHECK_STATE_SUCCESS,
} from '../types/periodic-check/edit-state'

import {
  DeletePeriodicCheck,
  DELETE_PERIODIC_CHECK,
  DELETE_PERIODIC_CHECK_ERROR,
  DELETE_PERIODIC_CHECK_SUCCESS,
} from '../types/periodic-check/delete'
import { AddPeriodicCheckFeedback, ADD_PERIODIC_CHECK_FEEDBACK, ADD_PERIODIC_CHECK_FEEDBACK_ERROR, ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS } from '../types/periodic-check/add-feedback'
import { EditPeriodicCheckFeedback, EDIT_PERIODIC_CHECK_FEEDBACK, EDIT_PERIODIC_CHECK_FEEDBACK_ERROR, EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS } from '../types/periodic-check/edit-feedback'

import {
  GetCustomerCurrentYearPeriodicChecks,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR,
  GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS,
} from '../types/periodic-check/get-customer-current-year'

import {
  GetPeriodicsChecksMetrics,
  GET_PERIODICS_CHECKS_METRICS,
  GET_PERIODICS_CHECKS_METRICS_ERROR,
  GET_PERIODICS_CHECKS_METRICS_SUCCESS,
} from '../types/periodic-check/get-metrics'

const currentAllPeriodicChecksStore = ({ periodicCheckStore }) => periodicCheckStore.all.data

function* getOneCheck({ payload }) {
  try {
    const { response, error } = yield call(services.periodicCheck.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_PERIODIC_CHECK_ERROR,
        payload: error
      })
    } else {
      yield put({
        type: GET_ONE_PERIODIC_CHECK_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_PERIODIC_CHECK_ERROR,
      payload: 'Error al obtener una inspección',
    })
  }
}

function* getLastCheck({ payload }) {
  console.log('getLastCheck saga')
  try {
    const { response, error } = yield call(services.periodicCheck.getLast, payload)
    if (error) {
      yield put({
        type: GET_LAST_PERIODIC_CHECK_ERROR,
        payload: error
      })
    } else {
      yield put({
        type: GET_LAST_PERIODIC_CHECK_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_LAST_PERIODIC_CHECK_ERROR,
      payload: 'Error al obtener una el último control periodico',
    })
  }
}

function* getAllChecks({ payload }) {
  console.log('getAllChecks saga')
  try {
    const { response, error } = yield call(services.periodicCheck.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_PERIODICS_CHECKS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_PERIODICS_CHECKS_ERROR,
      payload: 'Error al obtener todos los controles periódicos',
    })
  }
}

function* newCheck({ payload }) {
  console.log('newCheck saga')
  try {
    const { response, error } = yield call(services.periodicCheck.new, payload)
    if (error) {
      yield put({
        type: NEW_PERIODIC_CHECK_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const newPeriodicCheck = response
      const currentAllPeriodicChecks = yield select(currentAllPeriodicChecksStore);

      // Iterar sobre cada grupo en allInspections
      for (const group of currentAllPeriodicChecks) {
        // Iterar sobre los resultados dentro del grupo
        for (const result of group.results) {
          // Verificar si el cliente coincide
          if (result.customer._id === newPeriodicCheck?.customer?._id) {
            // Agregar la nueva inspección a la lista de inspecciones del cliente
            result.periodicChecks.push(newPeriodicCheck);
          }
        }
      }

      yield all([
        put({
          type: NEW_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
          payload: currentAllPeriodicChecks,
        }),
      ])
    }
  } catch {
    yield put({
      type: NEW_PERIODIC_CHECK_ERROR,
      payload: 'Error al crear una nuevo control periodico',
    })
  }
}

function* editCheck({ payload }) {
  console.log('editCheck saga')
  try {
    const { response, error } = yield call(services.periodicCheck.edit, payload)
    if (error) {
      yield put({
        type: EDIT_PERIODIC_CHECK_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllPeriodicChecks = yield select(currentAllPeriodicChecksStore);

      const updatedChecks = currentAllPeriodicChecks
        .map(group => ({
          ...group,
          results: group.results.map(result => {
            if (result.customer._id === response?.customer?._id) {
              return {
                customer: result.customer,
                periodicChecks: result.periodicChecks.map(periodicCheck => {
                  // Verificar si el periodicCheck coincide con el del response
                  if (response._id === periodicCheck._id) {
                    return {
                      ...periodicCheck,
                      customer: response['customer'],
                      date: response['date'],
                      state: response['state'],
                      type: response['type'],
                      _id: response['_id'],
                    };
                  }
                  return periodicCheck; // Si no coincide, lo dejamos igual
                }),
              };
            }
            return result; // Si el cliente no coincide, devolvemos el resultado sin cambios
          }),
        }))

      //Me traigo los periodic checks que tengo en el store
      //Busco entre esos periodic checks el editado
      //Reemplazo la data en ese periodic check.
      yield all([
        put({
          type: EDIT_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
          payload: { ...currentAllPeriodicChecks, data: updatedChecks },
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_PERIODIC_CHECK_ERROR,
      payload: 'Error al editar una inspección',
    })
  }
}

function* editCheckState({ payload }) {
  console.log('editCheckState saga')
  try {
    const { response, error } = yield call(services.periodicCheck.edit, payload)
    if (error) {
      yield put({
        type: EDIT_PERIODIC_CHECK_STATE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllPeriodicChecks = yield select(currentAllPeriodicChecksStore);

      const updatedChecks = currentAllPeriodicChecks
        .map(group => ({
          ...group,
          results: group.results.map(result => {
            if (result.customer._id === response?.customer?._id) {
              return {
                customer: result.customer,
                periodicChecks: result.periodicChecks.map(periodicCheck => {
                  // Verificar si el periodicCheck coincide con el del response
                  if (response._id === periodicCheck._id) {
                    return {
                      ...periodicCheck,
                      state: response.state, // Actualizamos el estado si coincide
                    };
                  }
                  return periodicCheck; // Si no coincide, lo dejamos igual
                }),
              };
            }
            return result; // Si el cliente no coincide, devolvemos el resultado sin cambios
          }),
        }))


      //Me traigo los periodic checks que tengo en el store
      //Busco entre esos periodic checks el editado
      //Reemplazo la data en ese periodic check.
      yield all([
        put({
          type: EDIT_PERIODIC_CHECK_STATE_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
          payload: { ...currentAllPeriodicChecks, data: updatedChecks },
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_PERIODIC_CHECK_STATE_ERROR,
      payload: 'Error al editar estado de una inspección',
    })
  }
}

function* addFeedback({ payload }) {
  console.log('addFeedback saga')
  try {
    const { response, error } = yield call(services.periodicCheck.edit, payload)
    if (error) {
      yield put({
        type: ADD_PERIODIC_CHECK_FEEDBACK_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllPeriodicChecks = yield select(currentAllPeriodicChecksStore);

      const updatedChecks = currentAllPeriodicChecks
        .map(group => ({
          ...group,
          results: group.results.map(result => {
            if (result.customer._id === response?.customer?._id) {
              return {
                customer: result.customer,
                periodicChecks: result.periodicChecks.map(periodicCheck => {
                  // Verificar si el periodicCheck coincide con el del response
                  if (response._id === periodicCheck._id) {
                    return {
                      ...periodicCheck,
                      customer: response['customer'],
                      date: response['date'],
                      state: response['state'],
                      type: response['type'],
                      _id: response['_id'],
                    };
                  }
                  return periodicCheck; // Si no coincide, lo dejamos igual
                }),
              };
            }
            return result; // Si el cliente no coincide, devolvemos el resultado sin cambios
          }),
        }))


      //Me traigo los periodic checks que tengo en el store
      //Busco entre esos periodic checks el editado
      //Reemplazo la data en ese periodic check.
      yield all([
        put({
          type: ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
          payload: { ...currentAllPeriodicChecks, data: updatedChecks },
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_PERIODIC_CHECK_ERROR,
      payload: 'Error al agregar feedback al control periodico',
    })
  }
}

function* editFeedback({ payload }) {
  console.log('editFeedback saga')
  try {
    const { response, error } = yield call(services.periodicCheck.edit, payload)
    if (error) {
      yield put({
        type: EDIT_PERIODIC_CHECK_FEEDBACK_ERROR,
        payload: error?.response?.status,
      })
    } else {
      //Me traigo los periodic checks que tengo en el store
      //Busco entre esos periodic checks el editado
      //Reemplazo la data en ese periodic check.
      yield all([
        put({
          type: EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ONE_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_PERIODIC_CHECK_ERROR,
      payload: 'Error al editar feedback al control periodico',
    })
  }
}

function* deleteCheck({ payload }) {
  console.log('deleteCheck saga')
  try {
    const { response, error } = yield call(services.periodicCheck.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_PERIODIC_CHECK_ERROR,
        payload: error?.response?.status,
      })
    } else {
      const currentAllPeriodicChecks = yield select(currentAllPeriodicChecksStore);

      const updatedChecks = currentAllPeriodicChecks
        .map(group => ({
          ...group,
          results: group.results.map(result => ({
            customer: result.customer,
            periodicChecks: result.periodicChecks.filter(periodicCheck => periodicCheck._id !== payload?.idPeriodicCheck),
          })),
        }))

      yield all([
        put({
          type: DELETE_PERIODIC_CHECK_SUCCESS,
          payload: response,
        }),
        put({
          type: GET_ALL_PERIODICS_CHECKS_SUCCESS,
          payload: updatedChecks,
        }),
      ])
    }
  } catch {
    yield put({
      type: DELETE_PERIODIC_CHECK_ERROR,
      payload: 'Error al eliminar una inspección',
    })
  }
}

function* getMetrics({ payload }) {
  console.log('getMetrics saga')
  try {
    const { response, error } = yield call(services.periodicCheck.getMetrics, payload)
    if (error) {
      yield put({
        type: GET_PERIODICS_CHECKS_METRICS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_PERIODICS_CHECKS_METRICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_PERIODICS_CHECKS_METRICS_ERROR,
      payload: 'Error al obtener métricas de los controles periódicos',
    })
  }
}

function* getCustomerCurrentYearPeriodicChecks({ payload }) {
  try {
    const { response, error } = yield call(services.periodicCheck.getCustomerCurrentYearPeriodicChecks, payload)
    if (error) {
      yield put({
        type: GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS_ERROR,
      payload: 'Error al obtener controles periódicos del cliente del año actual',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOnePeriodicCheck>(GET_ONE_PERIODIC_CHECK, getOneCheck)
  yield takeLatest<GetOnePeriodicCheck>(GET_LAST_PERIODIC_CHECK, getLastCheck)
  yield takeLatest<GetAllPeriodicsChecks>(GET_ALL_PERIODICS_CHECKS, getAllChecks)
  yield takeLatest<NewPeriodicCheck>(NEW_PERIODIC_CHECK, newCheck)
  yield takeLatest<EditPeriodicCheck>(EDIT_PERIODIC_CHECK, editCheck)
  yield takeLatest<DeletePeriodicCheck>(DELETE_PERIODIC_CHECK, deleteCheck)
  yield takeLatest<EditPeriodicCheckState>(EDIT_PERIODIC_CHECK_STATE, editCheckState)
  yield takeLatest<AddPeriodicCheckFeedback>(ADD_PERIODIC_CHECK_FEEDBACK, addFeedback)
  yield takeLatest<EditPeriodicCheckFeedback>(EDIT_PERIODIC_CHECK_FEEDBACK, editFeedback)
  yield takeLatest<GetPeriodicsChecksMetrics>(GET_PERIODICS_CHECKS_METRICS, getMetrics)
  yield takeLatest<GetCustomerCurrentYearPeriodicChecks>(GET_CUSTOMER_CURRENT_YEAR_PERIODIC_CHECKS, getCustomerCurrentYearPeriodicChecks)
}
